import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const ProductosFinancieros = () => {
  const navigate = useNavigate();
  const [productosFinancieros, setProductosFinancieros] = useState([]);

  const obtenerModalidades = async () => {
    const url = `${process.env.REACT_APP_SERVER_ADDRESS}/api/productos-financieros`;
    try {
      const res = await axios.get(url);
      if (res.status === 200) {
        setProductosFinancieros(res.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    obtenerModalidades();
  }, []);

  return (
    <main className="catalogo">
      <h1>Productos Financieros</h1>
      <Button
        onClick={() => navigate("./Nuevo")}
        variant="contained"
        size="small"
      >
        Crear Producto Financiero
      </Button>
      <div className="contenedor-tabla">
        <table>
          <thead>
            <tr>
              <th>Modalidad</th>
              <th>Tipo de Crédito</th>
              <th>Antiguedad</th>
              <th className="centrado"> Acciones</th>
            </tr>
          </thead>
          <tbody>
            {productosFinancieros.map((producto) => (
              <tr key={producto.IdProductoFinanciero}>
                <td>{producto.Modalidad}</td>
                <td>{producto.TipoCredito}</td>
                <td>{producto.AntiguedadFiscal}</td>
                <td>
                  <div className="contenedor-opciones">
                    <FontAwesomeIcon
                      className="icono"
                      icon={faPenToSquare}
                      onClick={() =>
                        navigate(`./${producto.IdProductoFinanciero}`)
                      }
                    />
                    <FontAwesomeIcon
                      className="icono"
                      icon={faTrashCan}
                      onClick={() =>
                        Swal.fire(
                          "Ups",
                          "No puedes eliminar productosFinancieros",
                          "warning"
                        )
                      }
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </main>
  );
};

export default ProductosFinancieros;
